import PropTypes from "prop-types";

export const CarouselProps = {
  options: PropTypes.object,
  renderItems: PropTypes.func,
  children: PropTypes.node,
  speed: PropTypes.number,
  pauseOnHover: PropTypes.bool,
  pauseOnDocumentScroll: PropTypes.bool,
  loop: PropTypes.bool,
  onInit: PropTypes.func,
};
